import { breakpointValues } from 'theme/themeBaseOptions';

export const isMobileViewport = (deviceType: string) => {
  // MUI's breakpoints.down() subtracts 0.05px to create an exclusive max-width boundary
  const isBelowMd = window.matchMedia(`(max-width: ${breakpointValues.md - 0.05}px)`).matches;
  const isPortrait = window.matchMedia('(orientation: portrait)').matches;
  const isShortHeight = window.matchMedia(`(max-height: ${breakpointValues.sm}px)`).matches;

  return isBelowMd || (!isPortrait && isShortHeight && deviceType === 'mobile');
};
